import { SelectItem } from "@mantine/core/lib/Select/types";

import { GetTenantsQuery, TenantStatus } from "../graphql/generated";
import { toHumanReadable } from "../utils/string.ts";

export type Tenant = GetTenantsQuery["tenants"]["data"][0];

export const tenantStatuses = Object.values(TenantStatus).map((status) => ({
  value: status,
  label: toHumanReadable(status),
}));

export const getTenantOptions = (
  data: Pick<Tenant, "id" | "name">[] | null | undefined
): SelectItem[] => {
  return (
    data?.map((tenant) => ({
      value: String(tenant.id),
      label: tenant.name,
    })) ?? []
  );
};
